// Meta Pixel tracking service
import TEXT_CONSTANTS from '../constants/text';

declare global {
  interface Window {
    fbq: any;
  }
}

export class MetaPixelService {
  static getPixelId(): string {
    return TEXT_CONSTANTS.TRACKING.META_PIXEL_ID;
  }

  static isInitialized(): boolean {
    return typeof window !== 'undefined' && window.fbq;
  }

  static initialize(): void {
    const pixelId = this.getPixelId();
    
    // Only initialize if not already done and pixel ID is set
    if (this.isInitialized() || pixelId === 'YOUR_PIXEL_ID') {
      return;
    }

    // Load Meta Pixel code
    const f: any = window;
    const b: any = document;
    const e = 'script';
    const v = 'https://connect.facebook.net/en_US/fbevents.js';
    
    if (f.fbq) return;
    const n: any = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e);
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);

    // Initialize with pixel ID and track page view
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }

  static trackEvent(eventName: string, parameters?: any): void {
    if (this.isInitialized()) {
      if (parameters) {
        window.fbq('track', eventName, parameters);
      } else {
        window.fbq('track', eventName);
      }
    }
  }

  static trackCustomEvent(eventName: string, parameters?: any): void {
    if (this.isInitialized()) {
      if (parameters) {
        window.fbq('trackCustom', eventName, parameters);
      } else {
        window.fbq('trackCustom', eventName);
      }
    }
  }

  // Standard e-commerce events
  static trackViewContent(contentId: string, contentType: string = 'product', value?: number, currency: string = 'INR'): void {
    this.trackEvent('ViewContent', {
      content_ids: [contentId],
      content_type: contentType,
      value: value,
      currency: currency
    });
  }

  static trackAddToCart(contentId: string, value: number, currency: string = 'INR'): void {
    this.trackEvent('AddToCart', {
      content_ids: [contentId],
      content_type: 'product',
      value: value,
      currency: currency
    });
  }

  static trackInitiateCheckout(value: number, currency: string = 'INR', numItems?: number): void {
    this.trackEvent('InitiateCheckout', {
      value: value,
      currency: currency,
      num_items: numItems
    });
  }

  static trackPurchase(value: number, currency: string = 'INR', contentIds?: string[]): void {
    this.trackEvent('Purchase', {
      value: value,
      currency: currency,
      content_type: 'product',
      content_ids: contentIds
    });
  }

  static trackSearch(searchString: string): void {
    this.trackEvent('Search', {
      search_string: searchString
    });
  }

  static trackAddToWishlist(contentId: string, value?: number, currency: string = 'INR'): void {
    this.trackEvent('AddToWishlist', {
      content_ids: [contentId],
      content_type: 'product',
      value: value,
      currency: currency
    });
  }

  static trackCompleteRegistration(): void {
    this.trackEvent('CompleteRegistration');
  }

  static trackLead(): void {
    this.trackEvent('Lead');
  }
}